module.exports = __webpack_public_path__ + "static/media/gps_icon.57425d81.svg";